import React from "react";
import { useRenameSiteMutation } from "../../hooks/use_site";
import { useModal } from "../../context/modal_provider";
import DialogForm from "../material_react_table/dialog_form";
import { FORM_ACTIONS } from "../../enums/form_actions_enum";

export function useRenameSiteDialog() {
  const { openDialogModal } = useModal();

  return (siteData) => {
    openDialogModal({
      dialogTabs: [
        {
          label: "Rename Site",
          component: <RenameSiteDialog siteData={siteData} />,
        },
      ],
    });
  };
}

export function RenameSiteDialog({ siteData }) {
  const { closeDialogModal } = useModal();
  const { mutate: renameSite, isPending } = useRenameSiteMutation({
    onSuccess: () => {
      closeDialogModal();
    },
  });

  return (
    <DialogForm
      dialogAction={FORM_ACTIONS.RENAME_SITE}
      selectedRow={siteData}
      onClose={closeDialogModal}
      isPending={isPending}
      handleConfirm={(data, action, dialogData) =>
        renameSite({
          siteId: data["site_id"],
          siteName: dialogData["site_name"],
        })
      }
    />
  );
}
